"use strict";
export default (() => {
  const masterCheckboxes = document.querySelectorAll("[data-master-checkbox]");
  if (masterCheckboxes.length === 0)
    return;
  masterCheckboxes.forEach((masterCheckbox) => {
    const { container, label, labelChecked, showOnCheck } = JSON.parse(
      masterCheckbox.getAttribute("data-master-checkbox")
    );
    const checkboxContainer = document.querySelector(container);
    const masterCheckboxInput = masterCheckbox.querySelector(
      'input[type="checkbox"]'
    );
    const masterCheckboxLabel = masterCheckbox.querySelector(".form-check-label");
    const showOnCheckElement = showOnCheck ? document.querySelector(showOnCheck) : null;
    if (!checkboxContainer) {
      console.error(
        `Checkbox container with selector '${container}' not found.`
      );
      return;
    }
    masterCheckboxInput.addEventListener("change", () => {
      const allChecked = masterCheckboxInput.checked;
      checkboxContainer.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = allChecked;
      });
      masterCheckboxLabel.textContent = allChecked ? labelChecked : label;
      if (showOnCheckElement) {
        showOnCheckElement.classList.toggle("d-none", !allChecked);
      }
    });
    const checkboxes = checkboxContainer.querySelectorAll(
      'input[type="checkbox"]'
    );
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const anyChecked = Array.from(checkboxes).some(
          (checkbox2) => checkbox2.checked
        );
        masterCheckboxInput.checked = anyChecked;
        masterCheckboxLabel.textContent = anyChecked ? labelChecked : label;
        if (showOnCheckElement) {
          showOnCheckElement.classList.toggle("d-none", !anyChecked);
        }
      });
    });
  });
})();
